import { Col, Layout, Row, Typography } from 'antd';
import React, { SFC } from 'react';
import styled from 'styled-components';
import ConsultaParticipaciones from '../images/escudoPuebla.png';

const Footer = styled(Layout.Footer)`
    margin-top:20px;
    text-align: left;
    background-color: white !important;
    box-shadow: -4px -1px 4px rgba(0, 21, 41, 0.08) !important;
    padding: 5px 50px !important;
`;

const Image = styled.img`
    left: 40px;
    bottom: 12px;
    max-width: 90px;
    height: 64px;
`;

const { Paragraph } = Typography;

export const AppFooter: SFC = () => (
    <Footer>
        <Row>
            <Col span={2}>
                <Image src={ConsultaParticipaciones} />
            </Col>
            <Col>
                <Paragraph>
                    © 2019 Gobierno de Puebla.
                </Paragraph>
            </Col>
        </Row>
    </Footer>
);
